// extracted by mini-css-extract-plugin
module.exports = {"Otp4InputContainer":"Otp4InputContainer__3b-PN","Otp6InputContainer":"Otp6InputContainer__2MWWn"};